import { Box, Stack, Grid2, TextField, Typography } from "@mui/material";
import { useGetStatesQuery } from "src/api/services/api";
import ActiveState from "./components/ActiveState";
import { ChangeEvent, useCallback, useMemo, useState } from "react";

const StateTracker = () => {
  const { data } = useGetStatesQuery();
  const [search, setSearch] = useState("");

  const states = useMemo(() => {
    if (data == null) return [];

    const regEx = new RegExp(search, "ig");
    return data.filter((state) => state.name.search(regEx) >= 0);
  }, [data, search]);

  const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
  }, []);

  return (
    <Stack gap={2}>
      <Typography variant="h4" fontWeight={600}>
        State Tracker
      </Typography>
      <TextField
        placeholder="State"
        sx={{ width: "300px" }}
        value={search}
        onChange={handleChange}
      />
      <Box mr={10}>
        <Grid2 container rowSpacing={2} columnSpacing={10}>
          {states?.map((s) => (
            <ActiveState activeState={s} key={s.id} />
          ))}
        </Grid2>
      </Box>
    </Stack>
  );
};

export default StateTracker;
